import BoxLoader from "../../../../general/boxLoader";
import React, {useEffect, useRef, useState} from "react";
import {useMySearchParams} from "../../../../../../hook/useMySearchParams";
import {useSearchParams} from "react-router-dom";
import {MtoJDateFormat} from "../../../../../../utils/date";
import {BIOMETRIC_TYPE} from "../../../../../../constants/constant/enum";
import {useGetPatientBiometricChartsData} from "../../../../../../hook/request/ehr/patientBiometric";
import HighchartsReact from "highcharts-react-official";
import Highcharts from "highcharts";
import {chartOptions} from "../../../../general/chartOptions";

type TChartProps = {
  patientId?: string;
  displayX?: boolean;
  displayY?: boolean;
  showLegend?: boolean;
  displayDataLabels?: boolean;
  showExportButton?: boolean;
  openTab?: string;
}

type TFilterValues = {
  type?: number;
  patient?: string;
  pageNumber?: string;
  perPage?: string;
  search?: string;
  sort?: string;
}


const PatientWeightChart = ({
  patientId,
  displayX = true,
  displayY = true,
  showLegend = true,
  displayDataLabels = false,
  showExportButton = true,
  openTab,
}: TChartProps) => {

  const [searchParams] = useSearchParams();
  const { getQueryParams } = useMySearchParams();
  const [data, setData] = useState([]);
  const [labels, setLabels] = useState([]);
  const [filterValues, setFilterValues] = useState<TFilterValues>({
    type: BIOMETRIC_TYPE.WEIGHT.value,
    patient: patientId ? patientId : '0',
    pageNumber: "0",
    perPage: "10",
    search: "",
    sort: "asc",
  });

  //services
  const getBiometricChartsRequest = useGetPatientBiometricChartsData(getQueryParams(filterValues), (openTab === 'weight' && filterValues?.patient !== '0'));

  useEffect(() => {
    let _filterValues = {};
    _filterValues = {
      ...filterValues,
      type: searchParams.get("type") || BIOMETRIC_TYPE.WEIGHT.value,
      patient: patientId,
      pageNumber: searchParams.get("pageNumber") || "0",
      perPage: searchParams.get("perPage") || "10",
      search: searchParams.get("search") || "",
      sort: searchParams.get("sort") || "asc",
    }
    setFilterValues(_filterValues)
  }, [searchParams, patientId]);

  useEffect(() => {
    if(!getBiometricChartsRequest.isPending && getBiometricChartsRequest?.data?.data?.result){
      const { data } = getBiometricChartsRequest?.data?.data?.result;
      let _weightData = [],
        _weightLabel = [];
      if(data){
        _weightData = data
          .map((item:any) => (item?.values[0]));
        _weightLabel = data
          .map((item:any) => (`${MtoJDateFormat(item?.label)}`));
      }
      setData(_weightData)
      setLabels(_weightLabel)
    }
  }, [getBiometricChartsRequest.data])

  const chartComponentRef = useRef<HighchartsReact.RefObject>(null);

  return (
    <div>
      {getBiometricChartsRequest.isPending ? <BoxLoader/> :
        <HighchartsReact
          highcharts={Highcharts}
          options={chartOptions({
            chartType: 'column',
            data: [data],
            dataNames: ['وزن'],
            labels: labels,
            chartTitle: 'نمودار وزن بیمار',
            displayXLabels: displayX,
            displayYLabels: displayY,
            displayDataLabels: displayDataLabels,
            showLegend: showLegend,
            showExportButton: showExportButton
          })} ref={chartComponentRef}
        />
      }
    </div>
  );
};

export default PatientWeightChart;